"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = Pagination;
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _IconButton = require("../button/IconButton");
var _iconNames = require("../icon/iconNames");
var _EnhancedMenu = require("../menu/EnhancedMenu");
var _Menu = require("../menu/Menu");
var _MenuTrigger = require("../menu/MenuTrigger");
var _Popover = require("../popover/Popover");
var _typography = require("../typography/typography");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Pagination(_ref) {
  var table = _ref.table,
    pageSize = _ref.pageSize,
    pageIndex = _ref.pageIndex,
    dataLength = _ref.dataLength,
    _ref$pageSizes = _ref.pageSizes,
    pageSizes = _ref$pageSizes === void 0 ? [5, 10, 20, 50] : _ref$pageSizes;
  var totalPages = table.getPageCount();
  var canGoToPreviousPage = table.getCanPreviousPage();
  var canGoToNextPage = table.getCanNextPage();

  /**
   * Button styles for enabling/disabling buttons when first or last page
   */
  var prevButtonClass = canGoToPreviousPage ? _classes.Classes.PAGINATION_BUTTON : "".concat(_classes.Classes.PAGINATION_BUTTON, " ").concat(_classes.Classes.PAGINATION_BUTTON_DISABLED);
  var nextButtonClass = canGoToNextPage ? _classes.Classes.PAGINATION_BUTTON : "".concat(_classes.Classes.PAGINATION_BUTTON, " ").concat(_classes.Classes.PAGINATION_BUTTON_DISABLED);
  return /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.PAGINATION
  }, /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.PAGINATION_INFO
  }, /*#__PURE__*/React.createElement(_typography.Caption, null, "Items per page"), /*#__PURE__*/React.createElement(_typography.Subheading2, null, /*#__PURE__*/React.createElement(_Popover.Popover, null, /*#__PURE__*/React.createElement(_MenuTrigger.MenuTrigger, null, /*#__PURE__*/React.createElement(_typography.Subheading2, {
    muted: true
  }, pageSize)), /*#__PURE__*/React.createElement(_Menu.Menu, {
    className: _classes.Classes.PAGINATION_PAGES_MENU
  }, /*#__PURE__*/React.createElement(_EnhancedMenu.EnhancedMenu, {
    className: _classes.Classes.PAGINATION_PAGES_MENU,
    items: pageSizes.map(function (size) {
      return {
        text: "".concat(size),
        onClick: function onClick() {
          return table.setPageSize(size);
        }
      };
    })
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_typography.Caption, {
    muted: true
  }, "Showing ", pageIndex * pageSize + 1, " - ", Math.min((pageIndex + 1) * pageSize, dataLength), " of ", dataLength))), /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.PAGINATION_NAV
  }, /*#__PURE__*/React.createElement(_IconButton.IconButton32, {
    icon: _iconNames.IconNames8.DOUBLE_CARET_LEFT,
    onClick: function onClick() {
      return table.setPageIndex(0);
    },
    className: prevButtonClass,
    "aria-label": "First page",
    disabled: !canGoToPreviousPage
  }), /*#__PURE__*/React.createElement(_IconButton.IconButton32, {
    icon: _iconNames.IconNames8.CARET_LEFT,
    onClick: function onClick() {
      return table.previousPage();
    },
    className: prevButtonClass,
    "aria-label": "Previous page",
    disabled: !canGoToPreviousPage
  }), /*#__PURE__*/React.createElement(_IconButton.IconButton32, {
    icon: _iconNames.IconNames8.CARET_RIGHT,
    onClick: function onClick() {
      return table.nextPage();
    },
    className: nextButtonClass,
    "aria-label": "Next page",
    disabled: !canGoToNextPage
  }), /*#__PURE__*/React.createElement(_IconButton.IconButton32, {
    icon: _iconNames.IconNames8.DOUBLE_CARET_RIGHT,
    onClick: function onClick() {
      var lastPage = totalPages - 1;
      if (pageIndex < lastPage) {
        table.setPageIndex(lastPage);
      }
    },
    className: nextButtonClass,
    "aria-label": "Last page",
    disabled: !canGoToNextPage
  })));
}